import { plannerStore } from '~/stores'
import { registerNotification } from './registry'

registerNotification('action:executed', {
  color:   (_, theme) => theme.semantic.positive,
  icon:    notification => {
    const action = plannerStore.getAction(notification.info.action)
    return action?.icon ?? 'star'
  },
})